import { CALL_API } from '../../api/';
import { Schemas } from '../../api/schema';
import * as ActionTypes from './actionTypes';

// Fetch all events
const fetchEvents = (nextPageUrl) => ({
  [CALL_API]: {
    types: [
      ActionTypes.FETCH_EVENTS_REQUEST,
      ActionTypes.FETCH_EVENTS_SUCCESS,
      ActionTypes.FETCH_EVENTS_FAILURE
      ],
    endpoint: nextPageUrl,
    schema: Schemas.EVENT_ARRAY
  }
});

// Fetch a single event
const fetchEvent = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.FETCH_EVENT_REQUEST,
      ActionTypes.FETCH_EVENT_SUCCESS,
      ActionTypes.FETCH_EVENT_FAILURE
      ],
    endpoint: `events/${id}`,
    schema: Schemas.EVENT
  }
});

// Fetch a single event
const fetchProEvents = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.FETCH_EVENTS_REQUEST,
      ActionTypes.FETCH_EVENTS_SUCCESS,
      ActionTypes.FETCH_EVENTS_FAILURE
      ],
    endpoint: `search?organizer_id=${id}`,
    schema: Schemas.SEARCH_RESULTS,
    resultProp: 'results',
  }
});

// Load all events action creator
export const loadEvents = (nextPage) => (dispatch, getState) => {
  const {
    //nextPageUrl = `events?_page=1&_limit=6`,
    nextPageUrl = `events`,
    pageCount = 0
  } = getState().pagination.eventsPaginated || {}

  if (pageCount > 0 && !nextPage) {
    return Promise.resolve();
  }
  if(pageCount > 0 && nextPage) {
    return dispatch({
      type: ActionTypes.NEXT_EVENTS_PAGE
    });
  }
  return dispatch(fetchEvents(nextPageUrl));
};

// Load pro events action creator
export const loadProEvents = (id) => (dispatch, getState) => {
  return dispatch(fetchProEvents(id));
};

// Load a single event action creator
export const loadEvent = (id, requiredFields = []) => (dispatch, getState) => {
  const event = getState().entities.events[id];
  if (event && requiredFields.every(key => event.hasOwnProperty(key))) {
    return Promise.resolve();
  }
  return dispatch(fetchEvent(id));
};



// WEBPACK FOOTER //
// ./src/modules/events/actions.js